import { Components, Theme } from '@mui/material/styles';

const smallDialogStyle = ({ theme }) => ({
  maxWidth: '408px',
  // on mobile, adjust to match BottomSheet
  [theme.breakpoints.down('md')]: {
    borderTopLeftRadius: '16px',
    borderTopRightRadius: '16px',
    '& .MuiDialogTitle-root': {
      ...theme.typography.h4,
      padding: '16px 16px 12px 16px',
      // close button
      '& ~ .MuiIconButton-root': {
        margin: '4px 10px 0 0',
      },
    },
    '& .MuiDialogContent-root': {
      padding: '16px',
    },
    '& .MuiDialogActions-root': {
      padding: '24px 16px 16px',
    },
  },
});

export const flowDialog: Components<Theme>['MuiDialog'] = {
  defaultProps: {
    fullWidth: true,
    maxWidth: 'md',
  },
  styleOverrides: {
    container: ({ theme }) => ({
      flexGrow: '1',
      // responsive
      [theme.breakpoints.down('md')]: {
        // move to bottom
        alignItems: 'flex-end',
      },
    }),
    paper: ({ theme, ownerState }) => ({
      borderRadius: '8px',
      boxShadow: theme.flowShadows.xs,
      // responsive
      [theme.breakpoints.down('md')]: {
        // full screen
        margin: '0',
        width: '100%',
        maxWidth: '100%',
        borderBottomLeftRadius: '0',
        borderBottomRightRadius: '0',
        // medium & large
        ...(['md', 'lg', 'xl'].includes(`${ownerState?.maxWidth}`) && {
          borderRadius: '0',
          height: '100%',
          maxHeight: '100%',
        }),
      },
    }),
    // small
    paperWidthXs: smallDialogStyle,
    paperWidthSm: smallDialogStyle,
    // medium
    paperWidthMd: {
      maxWidth: '624px',
    },
    // large
    paperWidthLg: {
      maxWidth: '1256px',
    },
    paperWidthXl: {
      maxWidth: '1256px',
    },
  },
};
